var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-carousel-slide',[_c('img',{class:_vm.isClickable ? 'pointer' : '',attrs:{"src":_vm.renderImage,"alt":_vm.popup.title},on:{"click":function($event){return _vm.moveToUrl()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }